import { urlReplace } from "helpers/url";
import Api from "./Api";

export default class ProjectPlanService {
	constructor(api) {
		this.api = api || new Api();
	}

	async getAll(params) {
		return this.api.get('/secure/project-plans', params);
	}

	async getById(id, params) {
		return this.api.get(urlReplace('/secure/project-plan/{id}', { id: id }), params);
	}

	async getReportsById(id, params) {
		return this.api.get(urlReplace('/secure/project-plan/{id}/reports', { id: id }), params);
	}

	async getAllWbsById(id, params) {
		return this.api.get(urlReplace('/secure/project-plan/{id}/wbs', { id: id }), params);
	}

	async updateByPrimavera(id, data, params) {
		return this.api.put(urlReplace('/secure/project-plan/{id}/import-primavera', { id: id }), data, params);
	}
}